import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';

@Component({
  selector: 'nx-ng-buy-single-button',
  templateUrl: './buy-single-button.component.html',
  styleUrls: ['./buy-single-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BuySingleButtonComponent {
  constructor(@Inject(I18NEXT_SERVICE) private i18n: ITranslationService) {}

  @Input()
  id = '';

  @Input()
  count = 0;

  @Input()
  maxCount = 1;

  @Input()
  separateRemoveLink = true;

  @Input()
  canOnlyRemove = false;

  @Output()
  quantityUpdated: EventEmitter<number> = new EventEmitter<number>();

  @ViewChild('menuButton')
  menuButton: ElementRef | undefined;

  get buttonId() {
    return `${this.id}-button`;
  }

  get removeButtonId() {
    return `${this.id}-remove-button`;
  }

  get classes(): string {
    if (this.count === 0) {
      return "{'neutral': true}";
    }
    return "{'amount': true}";
  }

  get label(): string | undefined {
    if (this.canOnlyRemove) {
      return this.i18n.t('button_removing');
    }
    if (this.count === 0) {
      return this.i18n.t('button_buy');
    }
    return this.count.toString();
  }

  get removeLabel(): string | undefined {
    return this.i18n.t('button_remove');
  }

  handleButtonClick(): void {
    if (this.count >= 1 || this.canOnlyRemove) {
      return;
    }
    this.quantityUpdated.emit(1);
    setTimeout(() => {
      this.focusOnButton();
    }, 0);
  }

  handleRemoveButtonClick(): void {
    this.quantityUpdated.emit(0);
    setTimeout(() => {
      this.focusOnButton();
    }, 0);
  }

  focusOnButton() {
    const menuElement = this.menuButton?.nativeElement as HTMLElement;
    menuElement?.focus();
  }

  handleBuyButtonKeyEvent(event: KeyboardEvent) {
    switch (event.code) {
      case 'Space':
      case 'Enter':
        if (this.count >= 1 || this.canOnlyRemove) {
          return;
        }

        this.quantityUpdated.emit(1);
        break;
    }
  }

  handleRemoveButtonKeyEvent(event: KeyboardEvent) {
    switch (event.code) {
      case 'Space':
      case 'Enter':
        this.quantityUpdated.emit(0);
        break;
    }
  }
}
